import type { BoardType } from "@/model/baseTypes";
import type { SignalId } from "@/store/search/signalDefinitions";

import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("search", name, data);

// Triggered when the user opens a search filter
export const searchFilterOpened = (filterName: string) => event("filter_opened", { filterName });

// triggered when the user changes the search text. Triggered once per focus
export const searchTextChanged = () => event("text_changed");

// triggered when the user select an item in the search sidebar
export const searchItemSelected = (fromBoard: BoardType, toBoard?: BoardType) =>
  event("item_selected", { fromBoard, toBoard });

// triggered when the user selects a team in the team filter. `externalTeamsShown`
// reflects whether external orgs were visible in the list at the time of selection.
export const teamSelected = (isExternal: boolean, externalTeamsShown: boolean) =>
  event("team_selected", { isExternal, externalTeamsShown });

// triggered when the user selects "linked only" in upper level links dropdown
export const upperLevelLinksLinkedSelected = () => event("upper_level_links_linked_selected");

// triggered when the user selects "unlinked only" in upper level links dropdown
export const upperLevelLinksUnlinkedSelected = () => event("upper_level_links_unlinked_selected");

// triggered when the user selects a specific feature in upper level links
export const upperLevelLinksFeatureSelected = (
  featureId: string,
  source: "search" | "sticky_note",
) => event("upper_level_links_feature_selected", { featureId, source });

// triggered when the user selects a signal in the top-menu Signals dropdown or the search filter
export const signalSelected = (signal: SignalId, source: "top_menu" | "search") =>
  event("signal_selected", { signal, source });
